import * as React from 'react';
import { Dispatch } from 'redux';
import axios, { AxiosError } from 'axios';
import { receiveAxiosError } from '@konicaminolta/common-react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { DatasetRefreshSchedule } from '../../types/Dataset/DatasetRefreshSchedule';

type DatasetRefreshScheduleProps = {
    dispatch: Dispatch;
    datasetId: string;
}

interface DatasetRefreshScheduleState {
    data: DatasetRefreshSchedule | undefined;
    isLoading: boolean;
    hasPermissions: boolean;
}


class DatasetRefreshScheduleDetails extends React.Component<DatasetRefreshScheduleProps, DatasetRefreshScheduleState> {
    public constructor(props: DatasetRefreshScheduleProps) {
        super(props);
        this.state = {
            data: undefined,
            isLoading: true,
            hasPermissions: true,
        };
    }

    public componentDidMount() {
        this.getDatasetRefreshHistoryRecords();
    }

    private getDatasetRefreshHistoryRecords() {
        axios
            .get<DatasetRefreshSchedule>(
                `./api/dataset/${this.props.datasetId}/schedule`
            )
            .then((response) => {
                const { data } = response;
                this.setState({ data: data, isLoading: false, hasPermissions: true });
                console.log(`days: ${data.days}`);
                console.log("Got the data!");
            })
            .catch((e: AxiosError) => {
                if (e.response && e.response.status == 401) {
                    this.setState({hasPermissions: false});
                }
                else if (e.response && e.response.status !== 404) {
                    this.props.dispatch(receiveAxiosError({ error: e }));
                }
                this.setState({ isLoading: false });
            });
    }

    render() {
        const NoDataComponent: React.FunctionComponent = (): React.ReactElement => {
            if (!this.state.isLoading && !this.state.hasPermissions) {
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">Insufficient permissions to view refresh schedule.</p>
                    </div>
                );
            }
            if (!this.state.isLoading) {
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">No refresh schedule was found.</p>
                    </div>
                );
            }
            else {
                return (
                    <div className="d-flex justify-content-center mt-3">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                );
            }
        };

        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <Card className="panel">
                            <Card.Header>
                                <Row>
                                    <Col md={6}>
                                        <h3>Dataset Refresh Schedule</h3>
                                    </Col>
                                    <Col md={6} className='text-end'>
                                    </Col>
                                </Row>
                            </Card.Header>
                            {this.state.data?.enabled === false && this.state.data?.isLiveConnection === true ?
                                <Card.Body>
                                    <Row>
                                        <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                                        <p className="text-center">Report utilizes a live connection and does not have a refresh schedule.</p>
                                        </div>
                                    </Row>
                                </Card.Body>
                                :
                                <Card.Body>
                                    <Row>
                                        <Col><strong>Days of the Week</strong></Col>
                                        <Col><strong>Times</strong></Col>
                                        <Col><strong>Time Zone</strong></Col>
                                        <Col><strong>Notify Option</strong></Col>
                                        <Col><strong>Enabled</strong></Col>
                                    </Row>
                                    {
                                    <Row>
                                    <Col>
                                        <ul>
                                            {this.state.data?.days.map((data) => <li key={data}>{data}</li>)}
                                        </ul>
                                    </Col>
                                    <Col>
                                        <ul>
                                            {this.state.data?.times.map((data) => <li key={data}>{data}</li>)}
                                        </ul>
                                    </Col>
                                    <Col>{this.state.data?.localTimeZoneId}</Col>
                                    <Col>{this.state.data?.notifyOption}</Col>
                                    <Col>{this.state.data?.enabled ? "Yes" : "No"}</Col>
                                    </Row>
                                    }                                
                                </Card.Body>
                            }
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default DatasetRefreshScheduleDetails;